<template>
  <v-card
    elevation=""
    class="px-7 mt-3 pt-2 pb-5"
  >
  <Loader :esActiva="mostrar_loader"/>
    <v-form  ref="form" v-model="usuario.valido">   
      <v-text-field
        v-model="usuario.nombre"
        label="*RAZÓN SOCIAL / NOMBRE"
        prepend-inner-icon="mdi-account-outline"
        :rules="[v => !!v || 'RAZÓN SOCIAL / NOMBRE es obligatorio']"
      ></v-text-field>

      <v-text-field
        v-model="usuario.rut"
        label="RUT / DOCUMENTO"
        onkeypress="return event.charCode != 32"
        prepend-inner-icon="mdi-card-account-details-outline"
      ></v-text-field>

      <v-text-field
        :disabled="usuario.login_social"
        label="*EMAIL"
        prepend-inner-icon="mdi-email-outline"
        v-model="usuario.correo"
        :rules="[v => !!v || 'El EMAIL es obligatorio', rules.email]"       
      ></v-text-field>      
      <v-text-field
        label="*CELULAR"
        prepend-inner-icon="mdi-cellphone"
        v-model="usuario.telefono"
        type="number"
        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        :rules="[
          v => !!v || 'El CELULAR es obligatorio',
          v =>
            (v && v.length) < Number(usuario.cantidad_digitos) ? `El CELULAR debe tener mínimo ${usuario.cantidad_digitos} dígitos`: 
            (v && v.length) > Number(usuario.cantidad_digitos) ? `El CELULAR debe tener máximo ${usuario.cantidad_digitos} dígitos`:
            (v && v.length) == Number(usuario.cantidad_digitos),
          v => v >= 0 || 'El CELULAR no puede ser negativo'
        ]"
      ></v-text-field>
      
      <v-text-field
        v-model="usuario.password"
        :append-icon="mostrar_pass ? 'mdi-eye' : 'mdi-eye-off'"
        v-if="!usuario.login_social"
        :rules="[v => !!v || 'La CONTRASEÑA es obligatoria', rules.password]"
        label="CONTRASEÑA"
        prepend-inner-icon="mdi-lock-outline"
        :type="mostrar_pass ? 'text' : 'password'"    
        @click:append="mostrar_pass = !mostrar_pass"    
        ></v-text-field>

      <v-text-field
        v-model="usuario.confirmar_password"
        v-if="!usuario.login_social"
        :rules="[v => !!v || 'CONFIRMAR CONTRASEÑA es obligatorio', password_match]"
        label="CONFIRMAR CONTRASEÑA"
        prepend-inner-icon="mdi-lock-outline"
        :append-icon="mostrar_confirmacion ? 'mdi-eye' : 'mdi-eye-off'"
        :type="mostrar_confirmacion ? 'text' : 'password'"    
        @click:append="mostrar_confirmacion = !mostrar_confirmacion"    
        ></v-text-field>      


      <v-text-field
        v-model="usuario.direccion"        
        :rules="[v => !!v || 'La DIRECCIÓN es obligatoria']"
        @click="$router.push('/confirmar_ubiacion')"
        @focus="$router.push('/confirmar_ubiacion')"
        label="*TU DIRECCIÓN"
        prepend-inner-icon="mdi-google-maps"
      >
        <template v-slot:append>
          <v-btn
            class="mb-2 mr-1"
            fab
            dark
            read
            small
            @click="$router.push('/confirmar_ubiacion')"
            color="primary"
          >
            <v-icon dark>
              mdi-map-search-outline
            </v-icon>
          </v-btn>
        </template>
      </v-text-field>     
    </v-form>
  </v-card>
</template>

<script>
import Usuario from "@/objetos/usuario";
import ValidarCorreoDebounce from "@/funciones/validar_correo_debounce"
import Loader from '@/components/Loader/Loader.vue';

export default {
  components: {    
    Loader
  },
  name: "formulario_registro",
  data: () => ({
    alert: true,
    usuario: Usuario,
    show1: false,
    icon_alert: "",
    color_alert: "",
    mostrar_pass: false,
    mostrar_confirmacion: false,
    social: "",
    mostrar_sucursal: false,
    mostrar_input_password: true,
    correo_valido: false,
    error_debounce: "",
    mostrar_loader: false,
    rules: {
      email: value => {
        if(!value) return true 
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Email invalido.'
      },
      password: value => {
        if(!value) return true 
        const pattern = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z!@#\\$%\\^&\\*\d]{8,}$/
        return pattern.test(value) || 'La contraseña debe contener mínimo 8 carácteres, 1 número'
        
      }         
      
    }
  }),
  mounted() {
    if(Usuario.clear_form == true){
      this.$refs.form.reset();
      Usuario.clear_form = false;
    }
    setTimeout(() => {
      this.alert = false;
    }, 3000);
      this.$root.$on("registrar_usuario", () => {
        if(this.usuario.valido && this.usuario.terminos && this.usuario.validacion) return
        this.$refs.form.validate()  
        /*Esto debe de descomentarse para activar validaciones con debounce*/          
        //if(!this.usuario.correo_valido) this.error_debounce="Email invalido."; 
      });
    
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    }, 
    password_match(){
      if(this.usuario.password === this.usuario.confirmar_password){
        return true
      }
      return  'Las contraseñas no coinciden'
    },
    validar_correo(){
      if(!this.usuario.correo) return;      
      this.validar = ValidarCorreoDebounce.bind(this)
      this.validar(this.usuario.correo)
    }
  },
};
</script>